// Generated by bin/build-brand-images.mjs. Do not edit asset paths by hand.
import {
  createBrandArtwork,
  type BrandArtwork,
  type EmptyStateIllustration,
  type HeroImageName,
} from './types';

export const HERO_ARTWORK: Readonly<Record<HeroImageName, BrandArtwork>> = {
  players: createBrandArtwork(
    {
      640: new URL('../../assets/brand-images/heroes/640/players.webp', import.meta.url).href,
      960: new URL('../../assets/brand-images/heroes/960/players.webp', import.meta.url).href,
      1280: new URL('../../assets/brand-images/heroes/1280/players.webp', import.meta.url).href,
    },
    3 / 2,
  ),
  teams: createBrandArtwork(
    {
      640: new URL('../../assets/brand-images/heroes/640/teams.webp', import.meta.url).href,
      960: new URL('../../assets/brand-images/heroes/960/teams.webp', import.meta.url).href,
      1280: new URL('../../assets/brand-images/heroes/1280/teams.webp', import.meta.url).href,
    },
    3 / 2,
  ),
  trainers: createBrandArtwork(
    {
      640: new URL('../../assets/brand-images/heroes/640/trainers.webp', import.meta.url).href,
      960: new URL('../../assets/brand-images/heroes/960/trainers.webp', import.meta.url).href,
      1280: new URL('../../assets/brand-images/heroes/1280/trainers.webp', import.meta.url).href,
    },
    3 / 2,
  ),
  tournaments: createBrandArtwork(
    {
      640: new URL('../../assets/brand-images/heroes/640/tournaments.webp', import.meta.url).href,
      960: new URL('../../assets/brand-images/heroes/960/tournaments.webp', import.meta.url).href,
      1280: new URL('../../assets/brand-images/heroes/1280/tournaments.webp', import.meta.url).href,
    },
    3 / 2,
  ),
  venues: createBrandArtwork(
    {
      640: new URL('../../assets/brand-images/heroes/640/venues.webp', import.meta.url).href,
      960: new URL('../../assets/brand-images/heroes/960/venues.webp', import.meta.url).href,
      1280: new URL('../../assets/brand-images/heroes/1280/venues.webp', import.meta.url).href,
    },
    3 / 2,
  ),
};

export const EMPTY_STATE_ARTWORK: Readonly<Record<EmptyStateIllustration, BrandArtwork>> = {
  bookings: createBrandArtwork(
    {
      128: new URL('../../assets/brand-images/empty-states/128/bookings.webp', import.meta.url)
        .href,
      256: new URL('../../assets/brand-images/empty-states/256/bookings.webp', import.meta.url)
        .href,
    },
    1,
  ),
  games: createBrandArtwork(
    {
      128: new URL('../../assets/brand-images/empty-states/128/games.webp', import.meta.url).href,
      256: new URL('../../assets/brand-images/empty-states/256/games.webp', import.meta.url).href,
    },
    1,
  ),
  teams: createBrandArtwork(
    {
      128: new URL('../../assets/brand-images/empty-states/128/teams.webp', import.meta.url).href,
      256: new URL('../../assets/brand-images/empty-states/256/teams.webp', import.meta.url).href,
    },
    1,
  ),
  tournaments: createBrandArtwork(
    {
      128: new URL('../../assets/brand-images/empty-states/128/tournaments.webp', import.meta.url)
        .href,
      256: new URL('../../assets/brand-images/empty-states/256/tournaments.webp', import.meta.url)
        .href,
    },
    1,
  ),
  chat: createBrandArtwork(
    {
      128: new URL('../../assets/brand-images/empty-states/128/chat.webp', import.meta.url).href,
      256: new URL('../../assets/brand-images/empty-states/256/chat.webp', import.meta.url).href,
    },
    1,
  ),
  notifications: createBrandArtwork(
    {
      128: new URL('../../assets/brand-images/empty-states/128/notifications.webp', import.meta.url)
        .href,
      256: new URL('../../assets/brand-images/empty-states/256/notifications.webp', import.meta.url)
        .href,
    },
    1,
  ),
  search: createBrandArtwork(
    {
      128: new URL('../../assets/brand-images/empty-states/128/search.webp', import.meta.url).href,
      256: new URL('../../assets/brand-images/empty-states/256/search.webp', import.meta.url).href,
    },
    1,
  ),
  clients: createBrandArtwork(
    {
      128: new URL('../../assets/brand-images/empty-states/128/clients.webp', import.meta.url).href,
      256: new URL('../../assets/brand-images/empty-states/256/clients.webp', import.meta.url).href,
    },
    1,
  ),
};
